import { AppRoute } from "@/routes/routes";

export enum EHttpErrorCode {
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  UNPROCESSABLE_ENTITY = 422,
  GATEWAY_TIMEOUT = 504,
  SERVER_ERROR = 500
}

export enum EDomainErrorCode {
  DOMAIN_ERROR = 'DOMAIN_ERROR',
  UNKNOWN = 'UNKNOWN',
}

export type TKnownErrorCode = EHttpErrorCode | EDomainErrorCode;

export interface TKnownError {
  code: TKnownErrorCode;
  message: string;
  /** If true, global handler will NOT show toast */
  silent?: boolean;
  /** Optional future redirect */
  redirectTo?: AppRoute;
  /** Raw error for debugging */
  originalError?: unknown;
  /** Ignore all guards and let the client handle the error */
  delegateToClient?: boolean
}